import { createContext } from 'react';
import { QueryQueueContextType } from './types';

export const QueryQueueContext = createContext<QueryQueueContextType | null>(null);
